import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class CareQualityStore {
  pathDetails: any[] = [];
  currentMeasure: string = '';
  subMeasure: string = '';
  ruleId: string = '';
  careQualityMeasuresList: string[] = [];
  careQualityMeasuresSubMeasure: Map<string, string> = new Map<string, string>();
  careQualityMeasureRuleID: Map<string, string> = new Map<string, string>();

  constructor() {
    makeObservable(this, {
      pathDetails: observable,
      setPathDetails: action,
      currentMeasure: observable,
      setcurrentMeasure: action,
      subMeasure: observable,
      setsubMeasure: action,
      ruleId: observable,
      setRuleId: action,
      careQualityMeasuresList: observable,
      careQualityMeasuresSubMeasure: observable,
      careQualityMeasureRuleID: observable,
      setcareQualityMeasureRuleID: action,
      setCareQualityMeasuresList: action,
      removeCareQualityMeasuresList: action,
      setCareQualityMeasuresSubMeasure: action,
      removeCareQualityMeasuresSubMeasure: action,
    });
    makePersistable(this, {
      name: 'CareQualityStore',
      properties: [
        'pathDetails',
        'currentMeasure',
        'subMeasure',
        'ruleId',
        'careQualityMeasuresList',
        'careQualityMeasuresSubMeasure',
        'careQualityMeasureRuleID',
      ],
      storage: window.localStorage,
    });
  }

  setPathDetails(pathDetails: any[]) {
    this.pathDetails = pathDetails;
  }

  setcurrentMeasure(currentMeasure: string) {
    this.currentMeasure = currentMeasure;
  }

  setsubMeasure(subMeasure: string) {
    this.subMeasure = subMeasure;
  }

  setRuleId(ruleId: string) {
    this.ruleId = ruleId;
  }

  setCareQualityMeasuresList(careQualityMeasuresList: string[]) {
    this.careQualityMeasuresList = careQualityMeasuresList;
  }

  removeCareQualityMeasuresList() {
    this.careQualityMeasuresList = [];
  }

  setCareQualityMeasuresSubMeasure(careQualityMeasuresMap: Map<string, string>) {
    this.careQualityMeasuresSubMeasure = careQualityMeasuresMap;
  }

  removeCareQualityMeasuresSubMeasure() {
    this.careQualityMeasuresSubMeasure = new Map<string, string>();
  }

  setcareQualityMeasureRuleID(careQualityMeasureRuleID: Map<string, string>) {
    this.careQualityMeasureRuleID = careQualityMeasureRuleID;
  }

  removeAllData() {
    this.pathDetails = [];
    this.currentMeasure = '';
    this.ruleId = '';
    this.subMeasure = '';
    this.careQualityMeasuresList = [];
    this.careQualityMeasuresSubMeasure = new Map<string, string>();
    this.careQualityMeasureRuleID = new Map<string, string>();
  }
}
export default CareQualityStore;
